import TkDialog from '../../components/popups/TkDialog/TkDialog';

class DialogUtils {
  private static dialog: any = {
    show: null,
    hide: null,
  };

  public static init() {
    this.dialog.show = (window as any).showDialog;
    this.dialog.hide = (window as any).hideDialog;
  }

  public static show(
    title: string,
    description: string,
    acceptCallback: () => void = null,
    declineCallback: () => void = null,
    descriptionHtmlRenderization: boolean = false,
    alertMode: boolean = false,
  ): Promise<void> {
    const promise = this.dialog.show(title, description, acceptCallback, declineCallback, descriptionHtmlRenderization, alertMode);

    return promise;
  }

  public static hide() {
    this.dialog.hide();
  }
}

export default DialogUtils;